var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOffMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.5727539,21.6894531c-1.5604248-3.8605957-4.0927734-7.1876221-7.2385864-9.7814941l-1.416687,1.416748 c2.9612427,2.4025879,5.3425293,5.5061035,6.8007812,9.1147461C45.9052734,22.9013672,46,23.4267578,46,24 s-0.0947266,1.0986328-0.2817383,1.5605469C42.2280273,34.1972656,33.5,40,24,40 c-3.3894653,0-6.6750488-0.7502441-9.6651001-2.0927734l-1.506897,1.506958C16.2514038,41.0742188,20.0632935,42,24,42 c10.3066406,0,19.7797852-6.3056641,23.5727539-15.6894531C47.855957,25.609375,48,24.8320312,48,24 S47.855957,22.390625,47.5727539,21.6894531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6658325,36.092041l1.416687-1.416748c-2.9613037-2.4025879-5.3425293-5.5061035-6.8007812-9.1147461 C2.0947266,25.0986328,2,24.5732422,2,24s0.0947266-1.0986328,0.2817383-1.5605469C5.7719727,13.8027344,14.5,8,24,8 c3.3894653,0,6.6751099,0.7502441,9.6651611,2.0926514l1.5068359-1.5068359C31.7485962,6.9257812,27.9367065,6,24,6 C13.6933594,6,4.2202148,12.3056641,0.4272461,21.6894531C0.144043,22.390625,0,23.1679688,0,24 s0.144043,1.609375,0.4272461,2.3105469C1.9876709,30.1711426,4.5200195,33.4981689,7.6658325,36.092041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,16c1.1073608,0,2.1625977,0.2266846,3.1225586,0.6352539l1.4960327-1.4960938 C27.2354736,14.4152832,25.6663208,14,24,14c-5.5141602,0-10,4.4863281-10,10c0,1.6662598,0.4152832,3.2354736,1.1392212,4.6186523 l1.4960327-1.4960938C16.2266846,26.1625977,16,25.1074219,16,24C16,19.5888672,19.5888672,16,24,16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,32c-1.1073608,0-2.1625977-0.2266846-3.1225586-0.6352539l-1.4960327,1.4960938 C20.7645264,33.5847168,22.3336792,34,24,34c5.5141602,0,10-4.4863281,10-10c0-1.6662598-0.4152832-3.2354736-1.1392212-4.6186523 l-1.4960327,1.4960938C31.7733154,21.8374023,32,22.8925781,32,24C32,28.4111328,28.4111328,32,24,32z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7.1126986,
    y: 23.0001068,
    transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -9.9411259 24)",
    width: 62.2253952,
    height: 1.9997864
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffMedium);
export default __webpack_public_path__ + "static/media/eye-off--medium.09385453854aec15c86e0a7f79ac55d0.svg";
export { ForwardRef as ReactComponent };